(function () {
  'use strict';

  if (window.__mrMapleRecentlyViewedInitialized) return;
  window.__mrMapleRecentlyViewedInitialized = true;

  var SECTION_SELECTOR = '[data-mm-recently-viewed-data]';
  var STORAGE_PREFIX = 'pxu-recentlyViewed-';
  var MAX_RECENTLY_VIEWED = 10;
  var MAX_STORAGE_AGE_SECONDS = 30 * 24 * 3600;

  function safeParse(value, fallback) {
    if (!value) return fallback;

    try {
      return JSON.parse(value);
    } catch (_) {
      return fallback;
    }
  }

  function getVersion(payload) {
    var currency = payload && payload.currency ? String(payload.currency) : 'USD';
    var rootUrl = window.Theme && window.Theme.routes && window.Theme.routes.root_url
      ? String(window.Theme.routes.root_url)
      : '/';
    return currency + '-' + rootUrl;
  }

  function getStorageKey(payload) {
    return STORAGE_PREFIX + getVersion(payload);
  }

  function getSectionRoot(payloadNode) {
    return payloadNode.closest('.recently-viewed--section') || payloadNode.parentElement;
  }

  function getRecentlyViewedItems(storageKey) {
    var items = safeParse(localStorage.getItem(storageKey), []);
    return Array.isArray(items) ? items : [];
  }

  function getStoredCards(storageKey) {
    var cards = safeParse(sessionStorage.getItem(storageKey), {});
    return cards && typeof cards === 'object' ? cards : {};
  }

  function isValidHandle(handle) {
    var normalized = String(handle || '').trim();
    return !!normalized && normalized !== 'null' && normalized !== 'undefined';
  }

  function writeRecentlyViewedItems(storageKey, items) {
    var now = Math.floor(Date.now() / 1000);
    var minTimestamp = now - MAX_STORAGE_AGE_SECONDS;
    var byHandle = {};

    (Array.isArray(items) ? items : []).forEach(function (item) {
      if (!item || !isValidHandle(item.handle)) return;

      var handle = String(item.handle).trim();
      var timestamp = Number(item.timestamp || 0);
      if (!isFinite(timestamp) || timestamp <= minTimestamp) return;

      if (!byHandle[handle] || timestamp > byHandle[handle].timestamp) {
        byHandle[handle] = {
          handle: handle,
          timestamp: timestamp,
        };
      }
    });

    var filtered = Object.keys(byHandle)
      .map(function (handle) {
        return byHandle[handle];
      })
      .sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });

    if (filtered.length > MAX_RECENTLY_VIEWED) {
      filtered = filtered.slice(filtered.length - MAX_RECENTLY_VIEWED);
    }

    try {
      localStorage.setItem(storageKey, JSON.stringify(filtered));
    } catch (_) {}

    return filtered;
  }

  function setBlockVisibility(sectionRoot, isVisible) {
    if (!sectionRoot) return;

    var block = sectionRoot.querySelector('[data-mm-recently-viewed-block]');
    var divider = sectionRoot.querySelector('[data-mm-recently-viewed-divider]');
    var railSection = sectionRoot.querySelector('.product-recently-viewed--section');

    [block, divider, railSection].forEach(function (node) {
      if (!node) return;
      node.classList.toggle('hide', !isVisible);
      if ('hidden' in node) {
        node.hidden = !isVisible;
      }
    });
  }

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function buildFetchUrl(handle) {
    if (!isValidHandle(handle)) return '';
    return '/products/' + encodeURIComponent(handle) + '?view=recently-viewed';
  }

  function markMissingProductHandle(handle) {
    var loader = window.MrMapleProductJsonLoader;
    if (!loader || typeof loader.markMissing !== 'function') return;
    loader.markMissing(handle);
  }

  function buildTimestampLabel(timeData, timestamp) {
    if (!timeData || !timestamp) return '';

    var now = Math.round(Date.now() / 1000);
    var secondsPast = now - timestamp;
    if (secondsPast < 0) return '';

    if (secondsPast < 60) {
      var secondsAgo = parseInt(secondsPast, 10);
      return secondsAgo === 1
        ? secondsAgo + ' ' + timeData.second + ' ' + timeData.ago
        : secondsAgo + ' ' + timeData.seconds + ' ' + timeData.ago;
    }

    if (secondsPast < 3600) {
      var minutesAgo = parseInt(secondsPast / 60, 10);
      return minutesAgo === 1
        ? minutesAgo + ' ' + timeData.minute + ' ' + timeData.ago
        : minutesAgo + ' ' + timeData.minutes + ' ' + timeData.ago;
    }

    if (secondsPast <= 86400) {
      var hoursAgo = parseInt(secondsPast / 3600, 10);
      return hoursAgo === 1
        ? hoursAgo + ' ' + timeData.hour + ' ' + timeData.ago
        : hoursAgo + ' ' + timeData.hours + ' ' + timeData.ago;
    }

    var date = new Date(timestamp * 1000);
    var currentDate = new Date(now * 1000);
    var yearSuffix = date.getFullYear() === currentDate.getFullYear()
      ? ''
      : ', ' + date.getFullYear();
    return date.toLocaleDateString(document.documentElement.lang || 'en', {
      month: 'long',
      day: 'numeric',
    }) + yearSuffix;
  }

  function addTimestampLabels(container, items, timeData) {
    items.forEach(function (item) {
      var target = container.querySelector(
        '[data-product-handle="' + selectorEscape(item.handle) + '"]'
      );
      if (!target) return;

      var label = buildTimestampLabel(timeData, Number(item.timestamp || 0));
      if (!label) return;

      var labelNode = document.createTextNode(label);
      target.insertBefore(labelNode, target.firstChild);
    });
  }

  async function ensureCardMarkup(storageKey, handles, cardSettings) {
    var storedCards = getStoredCards(storageKey);
    var missingHandles = new Set();
    if (storedCards.cardSettings) {
      Object.keys(storedCards.cardSettings).forEach(function (key) {
        if (storedCards.cardSettings[key] !== cardSettings[key]) {
          storedCards = {};
          sessionStorage.removeItem(storageKey);
        }
      });
    }

    storedCards.cardSettings = cardSettings;

    await Promise.all(handles.map(async function (handle) {
      if (!isValidHandle(handle)) {
        return;
      }

      if (storedCards[handle]) {
        return;
      }

      try {
        var requestUrl = buildFetchUrl(handle);
        if (!requestUrl) return;

        var response = await fetch(requestUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });
        if (response.status === 404 || response.status === 410) {
          missingHandles.add(handle);
          delete storedCards[handle];
          markMissingProductHandle(handle);
          return;
        }
        if (!response.ok) return;

        var markup = await response.text();
        if (!markup) return;
        storedCards[handle] = markup;
      } catch (_) {
        return;
      }
    }));

    try {
      sessionStorage.setItem(storageKey, JSON.stringify(storedCards));
    } catch (_) {}

    return {
      storedCards: storedCards,
      missingHandles: missingHandles,
    };
  }

  function buildCardsMarkup(storageKey, items) {
    var storedCards = getStoredCards(storageKey);
    var parser = new DOMParser();
    var markup = [];

    for (var i = items.length - 1; i >= 0; i -= 1) {
      var handle = items[i] && items[i].handle ? items[i].handle : '';
      if (!handle || !storedCards[handle]) continue;

      var parsed = parser.parseFromString(storedCards[handle], 'text/html');
      if (parsed.querySelector('.productgrid--item')) {
        markup.push(storedCards[handle]);
      }
    }

    return markup.join('');
  }

  async function hydrateSection(sectionRoot, payloadNode, options) {
    if (!sectionRoot) return;

    var config = options || {};
    var payload = safeParse(payloadNode.textContent, {});
    var storageKey = getStorageKey(payload);
    var items = getRecentlyViewedItems(storageKey);
    var currentProduct = payload && payload.recently_viewed_info ? payload.recently_viewed_info : null;

    if (!config.skipCurrentProduct && currentProduct && currentProduct.handle) {
      items = items.filter(function (item) {
        return item && item.handle !== currentProduct.handle;
      });
      items.push({
        handle: currentProduct.handle,
        timestamp: Math.floor(Date.now() / 1000),
      });
    }

    items = writeRecentlyViewedItems(storageKey, items);

    var container = sectionRoot.querySelector('[data-recently-viewed-container]');
    if (!container) return;

    if (!items.length) {
      container.innerHTML = '';
      setBlockVisibility(sectionRoot, false);
      return;
    }

    var cardResult = await ensureCardMarkup(
      storageKey,
      items.map(function (item) { return item.handle; }),
      payload && payload.product_card_settings ? payload.product_card_settings : {},
    );

    if (cardResult && cardResult.missingHandles && cardResult.missingHandles.size) {
      items = writeRecentlyViewedItems(
        storageKey,
        items.filter(function (item) {
          return item && !cardResult.missingHandles.has(item.handle);
        }),
      );

      if (!items.length) {
        container.innerHTML = '';
        setBlockVisibility(sectionRoot, false);
        return;
      }
    }

    var cardsMarkup = buildCardsMarkup(storageKey, items);
    if (!cardsMarkup) {
      container.innerHTML = '';
      setBlockVisibility(sectionRoot, false);
      return;
    }

    container.innerHTML = cardsMarkup;
    addTimestampLabels(container, items, payload.time);
    setBlockVisibility(sectionRoot, true);
    document.dispatchEvent(new CustomEvent('mm:cards:added', { bubbles: true }));
  }

  function removeItem(storageKey, handle) {
    var remainingItems = writeRecentlyViewedItems(
      storageKey,
      getRecentlyViewedItems(storageKey).filter(function (item) {
        return item && item.handle !== handle;
      }),
    );

    var cards = getStoredCards(storageKey);
    delete cards[handle];

    try {
      sessionStorage.setItem(storageKey, JSON.stringify(cards));
    } catch (_) {}

    return remainingItems;
  }

  function clearSection(sectionRoot, storageKey) {
    localStorage.removeItem(storageKey);
    sessionStorage.removeItem(storageKey);

    var container = sectionRoot.querySelector('[data-recently-viewed-container]');
    if (container) {
      container.innerHTML = '';
    }

    setBlockVisibility(sectionRoot, false);
  }

  function bindSection(sectionRoot, payloadNode) {
    if (!sectionRoot || sectionRoot.__mmRecentlyViewedBound) return;
    sectionRoot.__mmRecentlyViewedBound = true;

    sectionRoot.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var clearButton = target.closest('[data-clear-recently-viewed]');
      if (clearButton) {
        var clearPayload = safeParse(payloadNode.textContent, {});
        var clearStorageKey = getStorageKey(clearPayload);
        clearSection(sectionRoot, clearStorageKey);
        return;
      }

      var removeButton = target.closest('[data-remove-recently-viewed]');
      if (!removeButton) return;

      var handleHost = removeButton.closest('[data-product-handle]');
      var handle = handleHost ? handleHost.getAttribute('data-product-handle') : '';
      if (!handle) return;

      removeItem(getStorageKey(safeParse(payloadNode.textContent, {})), handle);
      hydrateSection(sectionRoot, payloadNode, { skipCurrentProduct: true });
    });
  }

  function initSection(payloadNode) {
    var sectionRoot = getSectionRoot(payloadNode);
    if (!sectionRoot) return;
    bindSection(sectionRoot, payloadNode);
    hydrateSection(sectionRoot, payloadNode);
  }

  function init(root) {
    (root || document).querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
